export const TypesUpdateApp = {
	SW_INIT: "SW_INIT",
	SW_UPDATE: "SW_UPDATE",
};

export default function UpdateAppReducer(state = {}, action) {
	switch (action.type) {
		case TypesUpdateApp.SW_INIT:
			return {
				...state,
				serviceWorkerInitialized: !state.serviceWorkerInitialized,
			};
		case TypesUpdateApp.SW_UPDATE:
			return {
				...state,
				serviceWorkerUpdated: !state.serviceWorkerUpdated,
				serviceWorkerRegistration: action.payload,
			};
		default:
			return state;
	}
}
